type Props = {
  columnAmount: number;
};

const TableBodyEmptyState = ({ columnAmount }: Props) => (
  <tr>
    <td colSpan={columnAmount}>
      <div className="p-4 text-sm text-center text-white font-bold">
        No se encontraron resultados
      </div>
    </td>
  </tr>
);

export default TableBodyEmptyState;
